import * as Sentry from "@sentry/react";

export function handleError(error: unknown) {
  Sentry.captureException(error);
}
